import { useCallback, RefObject } from 'react';

interface IUseScrollToElementOptions {
    containerRef: RefObject<HTMLElement>;
    elementSelector?: string;
    offset?: number; // Если нужно добавить отступ сверху
    behavior?: 'smooth' | 'auto';
    enabled?: boolean;
    block?: 'start' | 'center' | 'end' | 'nearest';
}

export const useScrollToElement = (options: IUseScrollToElementOptions) => {
    const {
        containerRef,
        elementSelector = '[data-grid="true"]', //по умолчанию исп-ся для ChangeableGrid
        offset = 20,
        behavior = 'smooth',
        enabled = true,
        block = 'start'
    } = options;

    const scrollToElement = useCallback(() => {
        if (!enabled) return;
        if (!containerRef.current) return;

        const container = containerRef.current;
        const targetElement = container.querySelector(elementSelector) as HTMLElement;
        
        if (!targetElement)  return;

        targetElement.scrollIntoView({
            block: block,
            behavior: behavior
        });

        if (offset > 0) {
            setTimeout(() => {
                const newContainerRect = container.getBoundingClientRect();
                const newTargetRect = targetElement.getBoundingClientRect();
                
                if (newTargetRect.top < newContainerRect.top + offset) {
                    const extraScroll = newTargetRect.top - newContainerRect.top + container.scrollTop - offset;
                    container.scrollTo({
                        top: Math.max(0, extraScroll),
                        behavior: behavior
                    });
                }
            }, 100);
        }
    }, [containerRef, elementSelector, offset, behavior, enabled, block]);

    return scrollToElement;
};